import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, args?: any): any {
    if(args === "style"){
      return this.sanitizer.bypassSecurityTrustStyle(value);
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/pipes/safe.pipe.ts